export const DEFAULT_COMMANDS = ["help", "clear"];
